// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"dp-AWmYfrWW","content":"dp-sRq9Jg01"};